"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwsRumLogger = void 0;
var aws_rum_web_1 = require("aws-rum-web");
var AwsRumLogger = /** @class */ (function () {
    function AwsRumLogger(RUM_GUEST_ROLE_ARN, RUM_IDENTITY_POOL_ID, RUM_ENDPOINT, APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION) {
        this.RUM_GUEST_ROLE_ARN = RUM_GUEST_ROLE_ARN;
        this.RUM_IDENTITY_POOL_ID = RUM_IDENTITY_POOL_ID;
        this.RUM_ENDPOINT = RUM_ENDPOINT;
        this.APPLICATION_ID = APPLICATION_ID;
        this.APPLICATION_VERSION = APPLICATION_VERSION;
        this.APPLICATION_REGION = APPLICATION_REGION;
        var config = {
            sessionSampleRate: 1,
            guestRoleArn: this.RUM_GUEST_ROLE_ARN,
            identityPoolId: this.RUM_IDENTITY_POOL_ID,
            endpoint: this.RUM_ENDPOINT,
            telemetries: [],
            allowCookies: false,
            enableXRay: false,
            disableAutoPageView: true,
        };
        try {
            this.awsRumInstance = new aws_rum_web_1.AwsRum(this.APPLICATION_ID, this.APPLICATION_VERSION, this.APPLICATION_REGION, config);
        }
        catch (error) {
            this.awsRumInstance = null;
            // Ignore errors thrown during CloudWatch RUM web client initialization
        }
    }
    AwsRumLogger.prototype.record = function (type, eventData) {
        if (this.awsRumInstance === null)
            return;
        this.awsRumInstance.recordEvent(type, eventData);
    };
    return AwsRumLogger;
}());
exports.AwsRumLogger = AwsRumLogger;
